export const USERS_SET_ADS = "users/set-ads";
export const USERS_SET_USERS = "users/set-users";
export const USERS_SET_SEARCH_PARAMS = "USERS_SET_SEARCH_PARAMS";
export const USERS_SHOW_EDIT_FORM = "USERS_SHOW_EDIT_FORM";
export const USERS_SET_SEARCH_RESULTS = "USERS_SET_SEARCH_RESULTS";
export const USERS_UPDATE_SEARH_RESULTS = "USERS_UPDATE_SEARH_RESULTS";
export const USERS_UPDATE_ONLINE_USERS_LIST = "USERS_UPDATE_ONLINE_USERS_LIST";
export const USERS_COPY_USERS_STATE = "USERS_COPY_USERS_STATE";
